export default __webpack_public_path__ + "static/media/phone.67da06ac.svg";